/** File uploads: a labelled picker and one function that sends the chosen file to POST /files. */
import { api } from '../core/api.js';
import { html } from '../core/html.js';

const MAX_MB = 25;
export const ACCEPT = {
  resume: '.pdf',
  chat: '.pdf,.doc,.docx,.ppt,.pptx,.xls,.xlsx,.csv,.txt,.md,.zip,.png,.jpg,.jpeg',
  submission: '.pdf,.doc,.docx,.xls,.xlsx,.csv,.txt,.md,.zip,.png,.jpg,.jpeg',
  material: '.pdf,.doc,.docx,.ppt,.pptx,.xls,.xlsx,.csv,.txt,.md,.zip,.png,.jpg,.jpeg',
};

export function filePicker(id, label, purpose, { name = id, help = `Up to ${MAX_MB} MB.`, req = false } = {}) {
  return html`<div class="field" data-req="${req}" data-type="file"><label for="${id}">${label}${req ? '' : html` <span class="mu">(optional)</span>`}</label>
    <input id="${id}" name="${name}" type="file" accept="${ACCEPT[purpose] || ''}"><span class="help">${help}</span><span class="err" role="alert">Choose a file.</span></div>`;
}

/** Upload the file in an <input type=file>. Resolves to the stored file record, or null if nothing was chosen. */
export async function uploadChosen(input, purpose) {
  const file = input?.files?.[0];
  if (!file) return null;
  if (file.size > MAX_MB * 1024 * 1024) throw new Error(`That file is larger than ${MAX_MB} MB.`);
  const form = new FormData();
  form.append('file', file);
  form.append('purpose', purpose);
  const { file: stored } = await api.upload('/files', form);
  return stored;
}

/** Open a stored file through a short-lived signed link. The tab opens inside the click so it is not blocked. */
export async function openFile(fileId) {
  const tab = window.open('', '_blank');
  try {
    const { url } = await api.get(`/files/${fileId}/link`);
    if (tab) {
      tab.opener = null;
      tab.location.href = url;
    } else window.location.href = url;
  } catch (error) {
    tab?.close();
    throw error;
  }
}

const kb = (n) => (n >= 1024 * 1024 ? `${(n / (1024 * 1024)).toFixed(1)} MB` : `${Math.max(1, Math.round(n / 1024))} KB`);

/** A document shared in a chat message: opens through a short-lived signed link. */
export function fileChip(file) {
  if (!file) return '';
  return html`<button type="button" class="btn soft sm" style="margin-top:6px;max-width:100%" data-act="file.open" data-id="${file.id}" title="${file.filename}">${file.filename} <span class="xs mu">${kb(file.size_bytes)}</span></button>`;
}

/** The paperclip next to a chat box. `act` is the data-change action that receives the chosen file input. */
export function attachButton(act) {
  return html`<label class="btn ghost icon" aria-label="Share a document" title="Share a document (notes, slides, PDF)" style="cursor:pointer">+<input type="file" hidden accept="${ACCEPT.chat}" data-change="${act}"></label>`;
}
